// Student/parent help screens (FAQs, Contact Us) built from the mobile app.
// Every string carries the SP_COMM_ prefix so it stays globally unique across
// saga watchers.
export const SP_COMM_GET_FAQS = 'SP_COMM_GET_FAQS'
export const SP_COMM_GET_INQUIRY_TYPES = 'SP_COMM_GET_INQUIRY_TYPES'
export const SP_COMM_SEND_FEEDBACK = 'SP_COMM_SEND_FEEDBACK'
